import React from "react";

function FullscreenModal({
  id,
  title = "Modal Title",
  BodyComponent = null,
  FooterComponent = null,
  size = "md", // sm, md, lg, xl
  fullscreen = false, // default false for medium modal
}) {
  const sizeClass = {
    sm: "modal-sm",
    md: "",
    lg: "modal-lg",
    xl: "modal-xl",
  }[size];

  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      aria-labelledby={`${id}Label`}
      aria-hidden="true"
    >
      <div
        className={`modal-dialog ${fullscreen ? "modal-fullscreen" : sizeClass}`}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id={`${id}Label`}>
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          {BodyComponent && <BodyComponent />}
         
            
         
        </div>
      </div>
    </div>
  );
}

export default FullscreenModal;
